module.exports = __webpack_public_path__ + "img/icon-list-active.5ce5b4ff.svg";